const actions = {

    PUBLIC_LIST_READ_COUNTRIES_REQUEST: 'PUBLIC_LIST_READ_COUNTRIES_REQUEST',
    PUBLIC_LIST_READ_COUNTRIES_SUCCESS: 'PUBLIC_LIST_READ_COUNTRIES_SUCCESS',
    PUBLIC_LIST_READ_COUNTRIES_FAILURE: 'PUBLIC_LIST_READ_COUNTRIES_FAILURE',

    PUBLIC_LIST_READ_STATES_REQUEST: 'PUBLIC_LIST_READ_STATES_REQUEST',
    PUBLIC_LIST_READ_STATES_SUCCESS: 'PUBLIC_LIST_READ_STATES_SUCCESS',
    PUBLIC_LIST_READ_STATES_FAILURE: 'PUBLIC_LIST_READ_STATES_FAILURE',

    PUBLIC_LIST_READ_CURRENCIES_REQUEST: 'PUBLIC_LIST_READ_CURRENCIES_REQUEST',
    PUBLIC_LIST_READ_CURRENCIES_SUCCESS: 'PUBLIC_LIST_READ_CURRENCIES_SUCCESS',
    PUBLIC_LIST_READ_CURRENCIES_FAILURE: 'PUBLIC_LIST_READ_CURRENCIES_FAILURE',

    PUBLIC_LIST_READ_MSIC_CODE_REQUEST: 'PUBLIC_LIST_READ_MSIC_CODE_REQUEST',
    PUBLIC_LIST_READ_MSIC_CODE_SUCCESS: 'PUBLIC_LIST_READ_MSIC_CODE_SUCCESS',
    PUBLIC_LIST_READ_MSIC_CODE_FAILURE: 'PUBLIC_LIST_READ_MSIC_CODE_FAILURE',

    readPublicCountriesList: () => ({
        type: actions.PUBLIC_LIST_READ_COUNTRIES_REQUEST,
    }),
    readPublicStatesList: countryCode => ({
        type: actions.PUBLIC_LIST_READ_STATES_REQUEST,
        countryCode,
    }),
    readPublicCurrenciesList: () => ({
        type: actions.PUBLIC_LIST_READ_CURRENCIES_REQUEST,
    }),
    readPublicMsicCodeList: () => ({
        type: actions.PUBLIC_LIST_READ_MSIC_CODE_REQUEST,
    }),
};

export default actions;
